import React from 'react';
import { IconLogoGoldie } from '@wds/icons';
import { Immutable } from '@wds/utils';
import { defineMessages, t } from '@sm/intl';

import { useHeaderTheme } from '../../theme';
import useStyles from './useStyles';
import { MomentiveLogo } from './MomentiveLogo';
import { Brand } from '../../types';

export const COPY = defineMessages({
  LOGO: {
    id: 'Logo.logoLabel',
    defaultMessage: 'Brand logo',
    description:
      '[Type: Label][Vis.: high] - This is the brand logo on the header.',
  },
});

export type LogoProps = Immutable<{
  brand: Brand;
  label?: string;
  link: string;
}>;

export const Logo = ({
  brand = 'SurveyMonkey',
  label = t(COPY.LOGO),
  link,
  ...rest
}: LogoProps): React.ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ theme });
  return (
    <span className={classes.logo} {...rest} aria-label="logo">
      <a href={link} className={classes.logo}>
        {brand === 'SurveyMonkey' && <IconLogoGoldie title={label} size="xl" />}
        {brand === 'Momentive' && <MomentiveLogo label={label} />}
      </a>
    </span>
  );
};
